// This is just a placeholder file for the 'Base' theme which is the Default Theme for all Pict templates.
// View source the file at `../../../../pict-section-form/source/providers/dynamictemplates/Pict-DynamicTemplates-DefaultFormTemplates.js`

module.exports = (
	{
		TemplatePrefix: 'Pict-MT-Base',
		Templates: [],
	}
);
